module.exports = __webpack_public_path__ + "media/assets/img/apojaws-8d363d2588b2c3cfb104d595109b8d0a.svg";